import { setAuthToken } from './tokenManager'

/**
 * Sets both access and refresh tokens, using access token as fallback for refresh
 * when refresh token is not provided (e.g., impersonation sessions).
 *
 * This pattern is used for impersonation tokens which are not refreshable.
 * We keep a refresh cookie only so auth guards treat the session as authenticated.
 *
 * @param accessToken - The access token to set
 * @param refreshToken - The refresh token to set (optional, defaults to accessToken)
 */
export function setTokensWithFallback(accessToken: string, refreshToken?: string): void {
    setAuthToken(accessToken, 'access')
    setAuthToken(refreshToken ?? accessToken, 'refresh')
}
